import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelDynamic as _vModelDynamic, mergeProps as _mergeProps, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "adm-input-wrapper" }
const _hoisted_2 = ["for"]
const _hoisted_3 = { class: "adm-input-control" }
const _hoisted_4 = ["id", "placeholder", "disabled"]
const _hoisted_5 = {
  key: 1,
  class: "adm-trailing-icon"
}
const _hoisted_6 = {
  key: 0,
  class: "adm-input-trailing-text"
}
const _hoisted_7 = {
  key: 0,
  class: "adm-input-error"
}
const _hoisted_8 = {
  key: 1,
  class: "adm-input-description"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_adm_icon = _resolveComponent("adm-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.classes)
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.label)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "adm-floating-label",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickLabel && _ctx.onClickLabel(...args)))
          }, [
            _createElementVNode("label", { for: _ctx.identifier }, _toDisplayString(_ctx.label), 9, _hoisted_2)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", _mergeProps({ ref: "inputRef" }, _ctx.$attrs, {
          id: _ctx.identifier,
          placeholder: _ctx.placeholder,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.value) = $event)),
          disabled: _ctx.disabled,
          onFocus: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onFocus && _ctx.onFocus(...args))),
          onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args)))
        }), null, 16, _hoisted_4), [
          [_vModelDynamic, _ctx.value]
        ])
      ]),
      (_ctx.trIcon)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_adm_icon, {
              icon: _ctx.trIcon,
              type: "round",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('clickTrailingIcon', $event)))
            }, null, 8, ["icon"])
          ]))
        : _createCommentVNode("", true)
    ]),
    ((_ctx.error && !_ctx.disabled) || _ctx.description)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_ctx.error && !_ctx.disabled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.error), 1))
            : (_ctx.description)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.description), 1))
              : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}